import { APPLICANT_BOARD_COLUMN_ORDER } from './RentalPortalApplicantBoard.constants'

export function getApplicantsByStage(items) {
  return Object.fromEntries(
    APPLICANT_BOARD_COLUMN_ORDER.map(stage => [
      stage,
      items.filter(item => item.stage === stage),
    ])
  )
}
